import { HubSpotSaveAssociationConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getHubspotSaveAssociationTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as HubSpotSaveAssociationConfig;

	return [
		{
			id: 'use-variable-token',
			selector: '[data-tour="use-variable-token"]',
			content:
				'This option changes the Access Token input behavior to allow free text or expression inputs.',
		},
		{
			id: 'access-token',
			selector: '[data-tour="access-token"]',
			content: 'Required: The HubSpot access token that will be used to validate the request.',
		},
		...(config.accessToken.trim().length > 0
			? [
					{
						id: 'object-type',
						selector: '[data-tour="object-type"]',
						content:
							'Required: Once a valid HubSpot access token is provided the task will fetch a list of available objects from the HubSpot environment.',
					},
					{
						id: 'from-object-id',
						selector: '[data-tour="from-object-id"]',
						content:
							'Required: The ID value of the object from which the association should be created.',
					},
					{
						id: 'to-object-type',
						selector: '[data-tour="to-object-type"]',
						content:
							'Required: Once a valid HubSpot access token is provided the task will fetch a list of available objects from the HubSpot environment.',
					},
					{
						id: 'to-object-id',
						selector: '[data-tour="to-object-id"]',
						content:
							'Required: The ID value of the object to which the association should be created.',
					},
				]
			: []),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
